import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Paper
} from 'material-ui';


const styles = {
  valueContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    marginLeft: '1em',
  },
  value: {
    marginBottom: '0',
  },
  valueName: {
    marginTop: '0',
  }
}
export default class NumberIndex extends Component {
  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div>
          <p style={styles.header}><b>{this.props.header}</b></p>
        </div>
        <div style={styles.valueContainer}>
          <h1 style={styles.value}>{this.props.value}</h1>
          <p style={styles.valueName}>{this.props.valueName}</p>
        </div>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/NumberIndex.js